<template>
  <div class="form-sec__content1 is-flex--align-center">
    <div class="form-sec__criteria">
      <div class="form-sec__criteria-innerdiv">
        <span class="crossIcon-span" @click="closeImageInfo">
          <MdIconClose color="spirits--600" />
        </span>
        <MdTypography
          class="mt-e-title"
          data-qa-id="image-criteria-title"
          variant="body1--medium"
          color="spirits--800"
          tag="h6"
        >
          {{ criteriaTitle }}
        </MdTypography>
        <ul class="mt-list">
          <li
            v-for="(desc, index) in uploadImageDescriptionLength"
            id="image-description"
            :key="index"
            class="mt-list__item"
            data-qa-id="image-description"
          >
            <MdTypography
              variant="micro1--regular"
              color="spirits--700"
              tag="span"
              v-html="$t(`pages.bundle.draft.${criteria}.criteria.description` + (index + 1), { minWidth: minWidth, minHeight: minHeight })"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script src="./index.js" />
<style lang="scss">
@import 'mpl-css/lib/assets/global/variables/fonts';
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/variables/breakpoints';
@import 'mpl-css/lib/assets/global/functions/index';
@import 'mpl-css/lib/assets/global/mfpfonts/fonts';

  .form-sec__content1  {
    border-left: rem(1) solid map-get($colors, 'spirits--300');
    height: 100%;


    @media screen and (max-width: map-get($breakpoints, 's'))  {
      flex-direction: column;
    }

    @media screen and (max-width: 576px)  {
      flex-direction: column;
    }

    .form-sec__criteria {
      background-color: map-get($colors, 'white');
      width: rem(264);

      @media screen and (max-width: map-get($breakpoints, 'm'))  {
        width: rem(224)
      }
       @media screen and (max-width: map-get($breakpoints, 'tab'))  {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 1000;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background-color: rgba(0, 0, 0, 0.25);
      }

      .mt-e-title {
        @extend .mfp-HelveticaNowMTText-Medium-16;
        margin-bottom: rem(11);
        color: map-get($colors, 'spirits--800');

      }

      .mt-list {
        color: map-get($colors, 'spirits--700');
        font-size: rem(11);
        line-height: rem(16);
        list-style-type: none;

        &__item {
          font-family: $mt-regular;

          &:not(:last-child) {
            margin-bottom: rem(12);

            @media screen and (max-width: map-get($breakpoints, 's'))  {
              margin-bottom: rem(8);
            }
          }

          &::marker {
            font-size: rem(8);
          }

          strong {
            font-family: $mt-medium;
            font-weight: 500;
          }
        }
      }

      .form-sec__criteria-innerdiv{
        padding: rem(32) rem(24);
        background-color: map-get($colors, 'white');
        @media screen and (max-width: map-get($breakpoints, 'tab'))  {
          border-top-left-radius: rem(16);
          border-top-right-radius: rem(16);
          position: relative;
        }
          .crossIcon-span{
            cursor: pointer;
            display: none;
            @media screen and (max-width: map-get($breakpoints, 'tab'))  {
              display: block;
              position: absolute;
              top: rem(16);
              right: rem(16);
            }
          }
      }
    }
  }
</style>
